import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PostCard } from "@/components/PostCard";
import { Bookmark } from "lucide-react";

export default function SavedPosts() {
  const { glossary } = useAuth();
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/saved-posts").then((r) => setPosts(r.data)); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
      <p className="text-xs uppercase tracking-[0.2em] font-bold text-terra flex items-center gap-2"><Bookmark size={14} /> Koleksiyon</p>
      <h1 className="font-serif text-4xl text-ink tracking-tight mt-1 mb-6">Kaydedilen Alıntılarım</h1>
      <div className="space-y-4">
        {posts.length === 0 && <p className="text-sm text-muted-foreground">Henüz kaydedilmiş alıntı yok. Akışta beğendiğin paylaşımları "Kaydet" ile buraya ekle.</p>}
        {posts.map((p) => <PostCard key={p.id} post={p} glossary={glossary} onDelete={() => {}} />)}
      </div>
    </div>
  );
}
